<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="info-content-container">
        <img
          src="@shared/assets/img/general/ServiceTitanBlackLogo.svg"
          alt="slack"
        >
      </div>
      <button
        type="button"
        class="ac-close-button"
        @click="toggle(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container">
      <p>
        Simplify and streamline your operations by integrating SmartAC.com with ServiceTitan.
        This integration aims to avoid double entry of data, ensuring seamless synchronization
        between both platforms. Enhance your workflow, reduce errors, and improve efficiency
        by having all your essential information in one place.
      </p>
      <div class="info-img-container">
        <img
          src="@shared/assets/img/general/ServiceTitanExampleOne.svg"
          alt="1-example"
        >
        <img
          src="@shared/assets/img/general/ServiceTitanExampleTwo.svg"
          alt="2-example"
        >
      </div>
      <div class="info-img-header">
        Features
      </div>
      <div>
        <p class="review-info">
          Synchronize customer details, appointments, invoices, and payment statuses between
          SmartAC.com and ServiceTitan to prevent redundant data entry
        </p>
        <p class="review-info">
          Ensure that data is updated in real-time across both platforms, providing you with
          the most current information for decision-making.
        </p>
        <p class="review-info">
          Streamline your workflow by managing appointments, dispatching, and invoicing more
          efficiently, saving time and reducing administrative overhead.
        </p>
        <p class="review-info">
          Empower members to book services directly based on real-time availability for each trade.
        </p>
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        type="button"
        class="info-form-button"
        @click="connect"
      >
        Connect
      </button>
    </div>
  </div>
</template>

<script>
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';

export default {
  name: 'TitanConnectPopup',
  mixins: [partnerSettingsMixin],
  props: {
    toggle: Function,
    serviceInfo: Object,
  },
  methods: {
    connect() {
      this.toggle(true, 'titan-installation-guide');
    },
  },
};
</script>

<style lang="scss" scoped>

.info-content-container {
  align-items: flex-start;
  display: inline-flex;
  gap: 8px;
  width: 100%;

  .info-header {
    margin-top: 5px;
    color: $BLACK;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
  }
}

.info-form-button {
  padding: 12px;
  height: 48px;
  border-radius: 6px;
  background-color: $NBLUE100;
  font-weight: 600;
  color: $WHITE;
  width: 255px;
}

.info-img-container {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  gap: 16px;
  width: 100%;
}

.info-img-header {
  margin-top: 10px;
  margin-bottom: 10px;
  color: $BLACK;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
}

.review-info:before {
  content: "• ";
}
</style>
